import {common_utils} from "../common/common_utils";

function game_3003()
{

}


game_3003.getWinInfo = function(obj)
{
  let winInfo = "";
  if(common_utils.isNull(obj))
  {
    return winInfo;
  }
  let Bet = 0;
  let BetNum = 0;
  let HitNum = 0;
  let Win = 0;
  let Odds  = 0;
  if(obj.Bet)
  {
    Bet = obj.Bet;
  }
  if(obj.Odds){
    Odds = obj.Odds;
  }
  if(obj.Win)
  {
    Win = obj.Win;
  }
  if(obj.BetNumber)
  {
    BetNum = obj.BetNumber;
  }
  if(obj.BetNumber)
  {
    HitNum = obj.HitNumber;
  }
  if(BetNum >= HitNum)
  {
    Odds = 0;
  }
  winInfo += "("+(Bet / 100).toFixed(2)+" x " +Odds+")"+" - " +(Bet / 100).toFixed(2);
  winInfo += " = " +(Win / 100).toFixed(2)+" - " +(Bet / 100).toFixed(2);
  winInfo += " = " +((Win-Bet) / 100).toFixed(2);
  return winInfo;
}

export {
  game_3003
};



// WEBPACK FOOTER //
// ./src/components/esports/game_3003.js